module.exports = __webpack_public_path__ + "static/media/BottomMenu.0f1afcb2.jpeg";